import { Pipe, PipeTransform } from '@angular/core';

/**
 * Send mode of a document, derived from the pipe separated flags string.
 *
 * The flags carry two orthogonal dimensions: the send channel (MAIL, SMS,
 * WHATSAPP, FIRMA_LINK...) and the send mode. A document without the
 * PARALLEL flag is requested sequentially, which is exactly the rule the
 * backend applies in ClosingMetasAction.
 *
 * Each mode renders a different Material icon ligature:
 *
 * - PARALLEL  -> sync_alt: two horizontal arrows pointing opposite ways at
 *   slightly different heights, read as "at the same time".
 * - SEQUENTIAL -> keyboard_double_arrow_right: two identical chevrons, one
 *   behind the other, read as "one after the other".
 *
 * Both ligatures exist in the Material Icons font the SPA loads (see
 * src/index.html). The SVGs live in google/material-design-icons under
 * src/action/sync_alt and src/hardware/keyboard_double_arrow_right.
 */
export const SEND_MODE_PARALLEL = 'PARALLEL';
export const SEND_MODE_SEQUENTIAL = 'SEQUENTIAL';

@Pipe({
    name: 'sendMode'
})
export class SendModePipe implements PipeTransform
{
    transform(flags: string): string
    {
        if (!flags)
        {
            return SEND_MODE_SEQUENTIAL;
        }

        return flags.split('|').indexOf(SEND_MODE_PARALLEL) != -1
            ? SEND_MODE_PARALLEL
            : SEND_MODE_SEQUENTIAL;
    }
}
